import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import shareIcon from './_assets/share.svg'

const Share = ({ onClick }) => {
  const handleOnClick = event => {
    event.stopPropagation()
    if (onClick) {
      onClick()
    }
  }

  return (
    <div className='share-button' onClick={handleOnClick}>
      <img className='share-icon' alt='share button' src={`${shareIcon}`} width={12} height={14} />
    </div>
  )
}

Share.propTypes = {
  onClick: PropTypes.func
}

export default Share
